import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Volumes/omar-projects/projects/mvp/mvp-website-new/layouts/default.vue").then(m => m.default || m))
}